

export const useToastStore = defineStore('toast', () => {
  const route = useRoute()
  const isToastOpen = ref(!!route.query.roleNotFound)

  const toggleToast = (visibility: boolean) => {
    isToastOpen.value = visibility
  }

  return {
    isToastOpen,
    toggleToast,
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useToastStore, import.meta.hot))
}
